import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LOGO from  '../images/logo.png'

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-kenya-orange shadow sticky-top">
      <div className="container">
        <Link
          className="navbar-brand d-flex align-items-center gap-2"
          to="/"
          onClick={() => setIsMenuOpen(false)}
        >
        <img
      src={LOGO}
      alt="Pride Rock Tours Logo"
      className="d-inline-block align-middle d-none d-md-block navbar-logo"
      style={{
        objectFit: 'contain', // Show the whole logo
        marginRight: 8,
        borderRadius: '4px',
        height: 120,
        width: 200, // Adjust width as needed
      }}
    />
          <span className="d-md-none fw-bold">Pride Rock Tours</span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse${isMenuOpen ? ' show' : ''}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-md-0">
            {navItems.map(item => (
              <li className="nav-item" key={item.path}>
                <Link
                  to={item.path}
                  className={`nav-link${location.pathname === item.path ? ' active text-kenya-yellow fw-bold' : ' text-white'}`}
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;